<template>
  <div>
    <a-row type="flex" class="row_item">
      <a-col :span="2" style="padding-top: 15px">
        <span v-if="index >= 0">{{ index + 1 }}、
          <a @click="to(item)">报关信息</a>
        </span>
        <span v-else>报关信息</span>
      </a-col>
      <a-col :span="22">
        <div :title="item.name">
          <span style="display: block; padding-left: 16px;">
            <span class="desc">类型：出口</span>
            <span class="desc" v-if="item.sell_contract_number">系统编号：{{ item.sell_contract_number }}</span>
            <span class="desc" v-if="item.system_contract_number">系统合同号：{{ item.system_contract_number }}</span>
            <span class="desc">合同协议号：{{ item.contract_protocol_number }}</span>
            <span class="desc">境内发货人：{{ item.shipper }}</span>
            <span class="desc">境外收货人：{{ item.recipient }}</span>
            <span class="desc">生产销售单位：{{ item.product_sales_location }}</span>
            <span class="desc">进口申报日期：{{ item.declaration_date }}</span>
            <span class="desc">离境口岸：{{ item.departure_port }}</span>
            <span class="desc">监管方式：{{ item.supervision_mode }}</span>
            <span class="desc">贸易国（地区）：{{ item.trading_nations }}</span>
            <span class="desc">运抵国（地区）：{{ item.arrival_country }}</span>
            <span class="desc">毛重：{{ item.gross_weight }}</span>
            <span class="desc">件数：{{ item.quantity }}</span>
            <span class="desc">货物名称：{{ item.product_name }}</span>
            <span class="desc">商品编码：{{ item.product_code }}</span>
            <span class="desc">数量及单位：{{ item.count }} {{ dictionaries.unit[item.unit] ? dictionaries.unit[item.unit] : '--' }}</span>
            <span class="desc">单价：{{ item.unit_price }}</span>
            <span class="desc">总价：{{ item.total_price }}</span>
            <span class="desc">币种：{{ dictionaries.currency[item.currency] }}</span>
            <span class="desc" v-if="item.country_of_origin">原产国：{{ item.country_of_origin }}</span>
            <span class="desc" v-if="item.customs_declaration_number">报关单号：{{ item.customs_declaration_number }}</span>
            <span class="desc" v-if="item.levy_exemption_type">征免：{{ item.levy_exemption_type }}</span>
            <span class="desc">已开启审批：
              <a-popconfirm
                title="确定开启审批吗?"
                :disabled="item.is_approval_needed"
                @confirm="() => approvalNeeded(item, 'trade_customs_declaration_out', item.status === 3)">
                <a-switch checked-children="是" un-checked-children="否" :checked="item.is_approval_needed" :disabled="item.is_approval_needed"/>
              </a-popconfirm>
            </span>
            <span class="desc" v-if="item.is_approval_needed">审批状态：<span :class="statusText[item.status < 0 ? 0 : item.status][0]">{{ item.is_approval_needed ? (dictionaries.approval_result[item.status] ? dictionaries.approval_result[item.status] : '无') : un_approval_needed_text }}</span></span>
            <span class="desc" v-action:add>已存档：
              <a-popconfirm
                title="确定存档吗?"
                :disabled="item.is_archived"
                @confirm="() => handleArchived(item, 'customs_declaration_out')">
                <a-switch checked-children="是" un-checked-children="否" :checked="item.is_archived" :disabled="item.is_archived"/>
              </a-popconfirm>
            </span>
            <span class="desc" v-if="item.create_by">创建人：{{ item.create_by }}</span>
            <span class="desc">创建时间：{{ item.create_time | dayjs }}</span>
          </span>
          <span style="padding-left: 16px;" class="desc" v-if="item.remark">备注：{{ item.remark }}</span>
          <div style="padding-left: 16px;" v-if="!item.is_archived && edit">
            <span class="desc">操作:</span>
            <span class="ope">
              <span @click="handleEditRecord(item, 'customs_declaration_out')">编辑</span>
              <a-popconfirm
                title="确定删除吗?"
                @confirm="() => handleDelete(item, 'customs_declaration_out')">
                <span>删除</span>
              </a-popconfirm>
              <a-popconfirm
                v-if="item.is_approval_needed && item.status === 3"
                title="确定重启审批?"
                @confirm="() => approvalNeeded(item, 'trade_customs_declaration_out', true)">
                <span>重启审批</span>
              </a-popconfirm>
            </span>
          </div>
          <div v-if="item.attachment.length > 0">
            <a-collapse :bordered="false">
              <template #expandIcon="props">
                <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
              </template>
              <a-collapse-panel key="2" header="附件" :style="customStyle">
                <a v-for="(attachment) in item.attachment" :key="attachment.id" :href="attachment.url" target="_blank" class="desc"><a-icon type="file" theme="filled" /> {{ attachment.name }}</a>
              </a-collapse-panel>
            </a-collapse>
          </div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { Dictionaries } from '@/common/AllConstant'
import SellContractRecord from '../modules/SellContractRecord'

export default {
  name: 'CustomsDeclarationOutInfo',
  components: {
    SellContractRecord
  },
  props: {
    item: {
      type: Object,
      default: () => {
        return null
      }
    },
    index: {
      type: Number,
      default: 0
    },
    edit: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      customStyle: 'background: #f7f7f7;border-radius: 4px;margin-bottom: 1px;border: 0;overflow: hidden',
      dictionaries: Dictionaries,
      recordVisible: false,
      sellContractRecordList: [],
      un_approval_needed_text: '未开启审批',
      statusText: {
        0: ['none', '无'],
        1: ['waiting', '审批中'],
        2: ['pass', '通过'],
        3: ['un_pass', '驳回']
      }
    }
  },
  methods: {
    to (item) {
      const path = '/trade/customs_declaration_out'
      this.$router.push({ path: path, query: { id: item.id } })
    },
    handleArchived (item, type) {
      this.$emit('handleArchived', item, type)
    },
    handleEditRecord (item, type) {
      this.$emit('handleEditRecord', item, type)
    },
    handleDelete (item, type) {
      this.$emit('handleDelete', item, type)
    },
    approvalNeeded (item, type, approval_again) {
      this.$emit('approvalNeeded', item, type, approval_again)
    },
    closeDrawer () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.desc {
  padding-right: 20px;
  height: 40px;
  line-height: 40px;
  display: inline-block;
}
.row_item {
  border-bottom: 1px solid #eeeeee;
  padding: 10px 20px;
  background-color: #f7f7f7;
  margin-top: 5px;
  border-radius: 10px;
}
.ope>span:hover {
  color: #2a99ff;
  cursor: pointer;
}
.ope>span:first-child {
  padding-left: 0px;
  height: 40px;
  line-height: 40px;
}
.ope>span:not(:first-child) {
  padding-left: 20px;
  height: 40px;
  line-height: 40px;
}
.content {
  /*color: #00A0E9;*/
  /*font-weight: bolder*/
}
.none {
  color: #333333;
}
.waiting {
  color: yellowgreen;
}
.pass {
  color: green;
}
.un_pass {
  color: red;
}
.space {
  margin-top: 5px;
  overflow-x: auto;
}
.important-content {
  font-weight: bold;
}
</style>
